import styled from 'styled-components';

export const SizeControlsWrapper = styled.div`
  margin-top: 6px;
`;

export const SizeFieldWrapper = styled.div`
  display: flex;
  align-items: center;

  &:first-child {
    margin-bottom: 14px;
  }
`;

export const SizeInputsWrapper = styled.div`
  margin-left: 10px;
`;

export const VideoSizeWrapper = styled.div`
  margin-bottom: 28px;
`;
